export type UserSetNewsStrategyAction = {
    type: 'userSetNewsStrategy';
    ideas: string[];
    tabId: string;
};

export const userSetNewsStrategy = (tabId: string, ideas: string[]): UserSetNewsStrategyAction => ({
    ideas,
    tabId,
    type: 'userSetNewsStrategy',
});

export type UserSetNewsUniverseAction = {
    type: 'userSetNewsUniverse';
    tabId: string;
    universeId: string | null;
};

export const userSetNewsUniverse = (tabId: string, universeId: string | null): UserSetNewsUniverseAction => ({
    type: 'userSetNewsUniverse',
    universeId,
    tabId,
});

export interface UserSetNewsSymbolFilter {
    type: 'userSetNewsSymbolFilter';
    symbol: string | null;
    tabId: string;
}

export const userSetNewsSymbolFilter = (tabId: string, symbol: string | null): UserSetNewsSymbolFilter => ({
    type: 'userSetNewsSymbolFilter',
    symbol,
    tabId,
});

export type UpdateNewsSymbolFilterAction = { type: 'updateNewsSymbolFilter'; tabId: string; symbol: string };
export const updateNewsSymbolFilter = (tabId: string, symbol: string): UpdateNewsSymbolFilterAction => ({
    tabId,
    symbol,
    type: 'updateNewsSymbolFilter',
});

export interface UserSetNewsSymbolRetention {
    type: 'userSetNewsSymbolRetention';
    symbolRetention: string;
    tabId: string;
}

export const userSetNewsSymbolRetention = (tabId: string, symbolRetention: string): UserSetNewsSymbolRetention => ({
    type: 'userSetNewsSymbolRetention',
    symbolRetention,
    tabId,
});

export type NewsWidgetActions =
    | UserSetNewsStrategyAction
    | UserSetNewsUniverseAction
    | UserSetNewsSymbolFilter
    | UpdateNewsSymbolFilterAction
    | UserSetNewsSymbolRetention;
